/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLinks } from '../fn/root/get-links';
import { GetLinks$Params } from '../fn/root/get-links';
import { RepresentationModelObject } from '../models/representation-model-object';


/**
 * Root resource link discovery endpoints. Requires EASYLOT_ADMIN role.
 */
@Injectable({ providedIn: 'root' })
export class RootService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLinks()` */
  static readonly GetLinksPath = '/';

  /**
   * Get root links.
   *
   * Finds and returns the root links.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLinks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinks$Response(params?: GetLinks$Params, context?: HttpContext): Observable<StrictHttpResponse<RepresentationModelObject>> {
    const obs = getLinks(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get root links.
   *
   * Finds and returns the root links.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLinks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinks(params?: GetLinks$Params, context?: HttpContext): Observable<RepresentationModelObject> {
    const resp = this.getLinks$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RepresentationModelObject>): RepresentationModelObject => r.body)
    );
  }

}
